// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6188 ? "0111293f" : chunkId) + "." + {"4989":"27ddf1ba6e6c007a","6188":"f0ce157760a67e59"}[chunkId] + ".js";
};